import client from './client';

export interface VariantSupplyRow {
  id: string;
  variantId: string;
  supplyId: string;
  supplyName: string;
  supplyType?: string;
  supplySku?: string;
  unitOfMeasure?: string;
  quantityRequired: number;
  notes?: string | null;
}

export interface VariantSupplyRequest {
  supplyId: string;
  quantityRequired: number;
  unitOfMeasure?: string;
  notes?: string;
}

export const variantSuppliesApi = {
  getForVariant: async (variantId: string): Promise<VariantSupplyRow[]> => {
    const response = await client.get<VariantSupplyRow[]>(`/supplies/variant/${variantId}`);
    return response.data;
  },

  add: async (variantId: string, data: VariantSupplyRequest): Promise<VariantSupplyRow> => {
    const response = await client.post<VariantSupplyRow>(`/supplies/variant/${variantId}`, data);
    return response.data;
  },

  update: async (variantSupplyId: string, data: VariantSupplyRequest): Promise<VariantSupplyRow> => {
    const response = await client.put<VariantSupplyRow>(`/supplies/variant-supply/${variantSupplyId}`, data);
    return response.data;
  },

  remove: async (variantSupplyId: string): Promise<void> => {
    await client.delete(`/supplies/variant-supply/${variantSupplyId}`);
  },
};
